import { Component, Input } from '@angular/core';
import { RxModel } from '@shared/models/rx-models/interfaces/rx-model';
import { RxVersion } from '@shared/models/enums/enums';
import { ScannerInfo } from '@modules/orders-details/models/scanner-info';

@Component({
	selector: 'rx-general-print',
	template: `
	<ng-container [ngSwitch]="isProcedureFlow">
		<rx-general-print-v1 *ngSwitchCase="true" [rxForPrint]="rxForPrint" [scannerInfo]="scannerInfo"></rx-general-print-v1>
		<rx-general-print-v0 *ngSwitchCase="false" [rxForPrint]="rxForPrint"></rx-general-print-v0>
	</ng-container>
	`,
})
export class GeneralRxPrintComponent {
	@Input() rxForPrint: RxModel;
	@Input() scannerInfo: ScannerInfo;

	get isProcedureFlow(): boolean {
		return this.rxForPrint.Version === RxVersion.ProcedureFlow;
	}
}
